import React, { useEffect } from 'react';
import data from '../data/bio'
import { useGlobalContext } from "../context/GlobalContext";

export const Home = () => {
  const { setLightTheme } = useGlobalContext()

  useEffect(() => {
    setLightTheme(false)
  }, [])

  const titleItems = data.title_items.map((item, i) => (
    <div className="b-home__title-item" key={i}>
      {item}
    </div>
  ))

  return (
    <div className="b-home">
      <div className="b-home__wrapper">
        <div className="b-home__title">
          {titleItems}
        </div>
        <div className="b-home__video-wrap">
          <div className="b-home__iframe-container">
            <iframe className="b-bio__iframe" src="https://player.vimeo.com/video/330837978?loop=1&title=0&byline=0&portrait=0?dnt=1" title="KozlowskaM teaser"
              frameborder="0" webkitallowfullscreen mozallowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}